import * as I18n from 'circe/I18n';
import { NAME as APP_NAME, ROUTES as VEHICLES_ROUTES } from 'domain/vehicle/constants';

export const NAME = `${APP_NAME}/VEHICLES`;

export const REDUCER_NAME = 'vehicles';

export const FORM_NAME = 'CREATE_VEHICLES';

export const ROUTES = {
  ROOT: `${VEHICLES_ROUTES.ROOT}/create`,
};

export const TRUCK_TYPES = {
  VAN: {
    label: I18n.str('VAN', 'Van'),
    value: 'VAN',
  },
  STRAIGHT_TRUCK_ENCLOSED: {
    label: I18n.str('STRAIGHT_TRUCK_ENCLOSED', 'Straight truck enclosed'),
    value: 'STRAIGHT_TRUCK_ENCLOSED',
  },
  TRACTOR_TRAILER_ENCLOSED: {
    label: I18n.str('TRACTOR_TRAILER_ENCLOSED', 'Tractor trailer enclosed'),
    value: 'TRACTOR_TRAILER_ENCLOSED',
  },
  OPEN: {
    label: I18n.str('OPEN', 'Open'),
    value: 'OPEN',
  },
  DRY_BOX: {
    label: I18n.str('DRY_BOX', 'Dry box'),
    value: 'DRY_BOX',
  },
  REEFER: {
    label: I18n.str('REEFER', 'Reefer'),
    value: 'REEFER',
  },
  FLAT_BED: {
    label: I18n.str('FLAT_BED', 'Flat bed'),
    value: 'FLAT_BED',
  },
  SIDE_CURTAIN: {
    label: I18n.str('SIDE_CURTAIN', 'Side curtain'),
    value: 'SIDE_CURTAIN',
  },
  BULKER: {
    label: I18n.str('BULKER', 'Bulker'),
    value: 'BULKER',
  },
};

export const OWNERSHIP_TYPES = [
  { value: 'OWNER', label: I18n.str('owner', 'Owner') },
  { value: 'LEASER', label: I18n.str('leaser', 'Leaser') },
];

export const TEMP_CLASSIFICATIONS = [
  { value: 'TC', label: 'TC' },
  { value: 'DRY', label: 'DRY' },
  { value: 'FROZEN', label: 'FROZEN' },
];
